import BusSystemApi from './_busSystemApi';

class EmployeeApi extends BusSystemApi {
  constructor() {
    super();
  }
  apiName = 'BusinessSystem';
  controllerName = 'Employees';

  /**
   * xóa tất cả nhân viên trong luồng getting (hợp nhất đơn vị)
   * vqphong - 23/07/2025
   */
  deleteGettingEmployees() {
    const request = {
      url: this.getAPIUrl() + `/delete-all-getting-employee`,
    };

    return this.deleteAsync(request);
  }
}

export default new EmployeeApi();